<template>
  <div class="custom-modal">
    <div class="modal-body">
      <div class="information-form" v-if="form != null">
        <div class="information-form-input">
          <label>{{ $t("settings.school") }}</label>
          <el-input v-model="form.title"></el-input>
          <span>{{ $errorMessage("title", validationErrors) }}</span>
        </div>
        <div class="information-form-input">
          <label>{{ $t("settings.department") }}</label>
          <el-input v-model="form.department"></el-input>
          <span>{{ $errorMessage("department",validationErrors) }}</span>
        </div>
        <div class="information-form-input">
          <label>{{ $t("settings.dateStart") }}</label>
              <el-date-picker
                v-model="form.dateStart"
                type="date"
                format="dd/MM/yyyy"
                placeholder="...">
              </el-date-picker>
          <span>{{ $errorMessage("dateStart",validationErrors) }}</span>
        </div>
        <div class="information-form-input">
          <label>{{ $t("settings.dateEnd") }}</label>
            <el-date-picker
                v-model="form.dateEnd"
                type="date"
                format="dd/MM/yyyy"
                placeholder="...">
              </el-date-picker>
          <span>{{ $errorMessage("dateEnd",validationErrors) }}</span>
        </div>
      </div>
    </div>
      <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{$t('close')}}</el-button>
        <el-button v-if="form.id != null" @click="deleteMe" type="danger">{{ $t("delete")}}</el-button>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveSchool'" @click="saveSchool" >{{$t('save')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
export default {
  props: ['id'],
  name: "AddJob",
  data() {
  return {
    moment,
    form: {
        id: null,
        title: null,
        department: null,
        dateStart: null,
        dateEnd: null
    },
    loading:false,
    timeout:null,
    validationErrors:[],
  }
  },
  computed: {
    user(){
      return this.$store.getters.getUser;
    },
  },

  created(){
    if(this.id != null && this.id != undefined){
      var fIndex = this.user.schools.findIndex(x => x.id == this.id);
      if(fIndex != -1){
      this.form = this.user.schools[fIndex];
      }
    }
  },
  methods: {
    deleteMe(){
      this.$emit('closeDialog');
      this.$emit('deleteMe', this.form.id);
    },
    async saveSchool() {
      this.loading = 'saveSchool';
      if(this.timeout != null) clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => {
      var res = await this.$store.dispatch("addUpdateAccountSchool", {...this.form});
      this.validationErrors = res.data.validationErrors;
      if (!res.data.hasError) {
       await this.$store.dispatch('getUser');
        this.form = res.data.data.item;
      }
      this.loading = false;
      }, 500);

    }
  }
};
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/AddSchool.vue